import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import JoinPage from "./pages/attendee/JoinPage";
import ListenPage from "./pages/attendee/ListenPage";
import LoginPage from "./pages/operator/LoginPage";
import OperatorLayout from "./pages/operator/Layout";
import ConferencesPage from "./pages/operator/ConferencesPage";
import SessionsPage from "./pages/operator/SessionsPage";
import SessionControlPage from "./pages/operator/SessionControlPage";
import SpeakersPage from "./pages/operator/SpeakersPage";
import DictionariesPage from "./pages/operator/DictionariesPage";
import DictionaryPage from "./pages/operator/DictionaryPage";
import OperatorsPage from "./pages/operator/OperatorsPage";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* The bare address opens the admin panel (which asks for sign-in when needed).
            Attendees never use it: their QR codes and links go straight to /join/<code>. */}
        <Route path="/" element={<Navigate to="/operator" replace />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/join/:code" element={<JoinPage />} />
        <Route path="/listen/:code/:lang" element={<ListenPage />} />

        <Route path="/operator/login" element={<LoginPage />} />
        <Route path="/operator" element={<OperatorLayout />}>
          <Route index element={<Navigate to="conferences" replace />} />
          <Route path="conferences" element={<ConferencesPage />} />
          <Route path="conferences/:conferenceId" element={<SessionsPage />} />
          <Route path="sessions/:sessionId/control" element={<SessionControlPage />} />
          <Route path="speakers" element={<SpeakersPage />} />
          <Route path="dictionaries" element={<DictionariesPage />} />
          <Route path="dictionaries/:dictionaryId" element={<DictionaryPage />} />
          <Route path="operators" element={<OperatorsPage />} />
          {/* the old single-glossary address */}
          <Route path="terminology" element={<Navigate to="/operator/dictionaries" replace />} />
          {/* A mistyped operator URL stays in the operator area (and asks for sign-in)
              instead of falling through to the attendee join page. */}
          <Route path="*" element={<Navigate to="/operator/conferences" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/join" replace />} />
      </Routes>
    </AuthProvider>
  );
}
